import type { SVGProps } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

export const ProModeIcon = (
  props: SVGProps<SVGSVGElement> & { size?: Unit }
) => {
  const { size = 3 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      style={{ height: unitMapping[size], width: 'auto' }}
      {...props}
    >
      <path
        d="M16.081 9.3949H16.4653H16.4677V7.05068L20 11.4354V17.5764L15.0005 22.4877L13.2475 15.6094H10.6493L8.69939 22.5H8.59613L4 17.9389V6.56567L8.11346 9.70844H8.62494V1.5L16.081 9.3949Z"
        fill="currentColor"
      />
    </svg>
  );
};
